export enum BookingType {
  NORMAL = 'NORMAL',
  ABO = 'ABO',
  INFIX = 'INFIX',
  SERVICE = 'SERVICE',
  POINTS = 'POINTS',
}
